import { render, staticRenderFns } from "./AnswersOverview.vue?vue&type=template&id=3dcf31d4&"
import script from "./AnswersOverview.vue?vue&type=script&lang=js&"
export * from "./AnswersOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports